import React from 'react';
import PropTypes from 'prop-types';
import svg from './icon.svg';

interface IconProps {
    icon: string;
    className?: string;
    onClick?: () => void;
}

const Icon = ({ icon, className, onClick }: IconProps) => {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" onClick={onClick}>
            <use href={`${svg}#${icon}`} xlinkHref={`${svg}#${icon}`} />
        </svg>
    );
};

export default Icon;
